import { DropDownBox } from "devextreme-react/drop-down-box";

import DataGrid, {
  Selection,
  Paging,
  Scrolling,
  SearchPanel,
} from "devextreme-react/data-grid";
import { useState } from "react";

const LookupEdit = ({
  defaultValue,
  dataSource,
  columns = ["id", "name"],
  displayMember = "name",
  valueMember = "id",
  children,
  onValueChanged,
}) => {
  const [opened, setOpened] = useState(false);
  const [value, setValue] = useState(defaultValue);
  const onChanged = (data) => {
    setValue(data);
    onValueChanged(data);
    setOpened(false);
  };
  const renderGrid = () => {
    return (
      <DataGrid
        width="auto"
        columnAutoWidth={true}
        showColumnLines={true}
        showRowLines={true}
        showBorders={true}
        rowAlternationEnabled={true}
        dataSource={dataSource}
        columns={columns}
        hoverStateEnabled={true}
        onSelectionChanged={(e) => {
          if(e.selectedRowKeys[0].id === undefined){
            onChanged(e.selectedRowsData[0]);
          }else{
            onChanged(e.selectedRowKeys[0].id);
          }
        }}
        height="100%"
        className="no-left-margin-search "
      >
        <SearchPanel visible={true} width="100%" />
        <Selection mode="single" />
        <Scrolling mode="virtual" />
        <Paging enabled={true} pageSize={10} />
      </DataGrid>
    );
  };

  return (
    <DropDownBox
      value={value}
      valueExpr={valueMember}
      displayExpr={displayMember}
      deferRendering={false}
      showClearButton={true}
      dataSource={dataSource}
      contentRender={renderGrid}
      opened={opened}
      dropDownOptions={{
        width: "auto",
        closeOnOutsideClick: true,
        onHiding: () => {
          setOpened(false);
        },
      }}
      width="100%"
      onValueChanged={(e) => {
        if(typeof e.value === 'object' && e.value !== null && e.value !== undefined){
          onChanged(e.value.id);
        }else{
          onChanged(e.value);
        }
      }}
      onOptionChanged={(e) => {
        if (e.name === "opened") {
          setOpened(true);
        }
      }}
    >
      {children}
    </DropDownBox>
  );
};

export default LookupEdit;
